import React, { useCallback, useEffect, useState } from 'react';
import { Page, PageNavigation } from '@ui/components';
import { getRegions, IRegion } from '@ui/api/v2/regions.api';

import RegionCard from './RegionCard';

import './Regions.less';
import RegionForm from './RegionForm';

export function Regions() {
  const [regions, setRegions] = useState<IRegion[]>([]);

  const [editRegion, setEditRegion] = useState<IRegion>();

  const fetchRegions = useCallback(async () => {
    const { data } = await getRegions();
    if (data) {
      setRegions(data.regions);
    }
  }, []);

  useEffect(() => {
    void fetchRegions();
  }, [fetchRegions]);

  const resetEditRegion = useCallback(() => {
    setEditRegion(undefined);
  }, []);

  const onRegionCreate = useCallback((region: IRegion) => {
    setRegions(r => [...r, region]);
  }, []);

  const onRegionUpdate = useCallback((region: IRegion) => {
    setRegions(r =>
      r.map(m => {
        if (m.id === region.id) {
          return region;
        }
        return m;
      }),
    );
  }, []);

  const onMarketDelete = useCallback((cityId: number) => {
    setRegions(c => c.filter(m => m.id !== cityId));
  }, []);

  return (
    <div className="regions">
      <PageNavigation title="Города" />
      <Page>
        <Page.LeftSide>
          <RegionForm
            region={editRegion}
            onRegionCreate={onRegionCreate}
            onRegionUpdate={onRegionUpdate}
            resetEditRegion={resetEditRegion}
          />
        </Page.LeftSide>
        <Page.Content>
          <div className="regions__wrapper">
            {[...regions]
              .sort((a, b) => (a.name < b.name ? -1 : 1))
              .map(m => (
                <RegionCard
                  key={m.id}
                  region={m}
                  setEditRegion={setEditRegion}
                  onDelete={onMarketDelete}
                />
              ))}
          </div>
        </Page.Content>
      </Page>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Regions/Regions.tsx